// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:59BLiW */\n.GERwI{display:none}.LXTCf{display:inline-flex}@media (min-width:768px){.GERwI{display:inline-flex}.LXTCf{display:none}}.dDXNh{align-items:center;display:flex;gap:var(--audio-spacing-12)}.mRAMB{flex-shrink:0;height:1.25rem;width:1.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wide": "GERwI",
	"narrow": "LXTCf",
	"item": "dDXNh",
	"icon": "mRAMB"
};
export default ___CSS_LOADER_EXPORT___;
